/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_shipmentQuote">;
    readonly " $refType": "PdpRespSidebarBlurbs_shipmentQuote";
};
export type PdpRespSidebarBlurbs_shipmentQuote$data = PdpRespSidebarBlurbs_shipmentQuote;
export type PdpRespSidebarBlurbs_shipmentQuote$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipmentQuote">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
(node as any).hash = 'e695037e2ad104771c2c52d9d5e7fd71';
export default node;
